import { render } from "./CreateQuotaTariff.vue?vue&type=template&id=7b2a975c&scoped=true"
import script from "./CreateQuotaTariff.vue?vue&type=script&lang=js"
export * from "./CreateQuotaTariff.vue?vue&type=script&lang=js"

import "./CreateQuotaTariff.vue?vue&type=style&index=0&id=7b2a975c&lang=scss&scoped=true"

import exportComponent from "/home/vinicius.valle/projetos/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b2a975c"]])

export default __exports__